'use client';

import NextLink, { type LinkProps } from 'next/link';
import { forwardRef, type AnchorHTMLAttributes, type ReactNode } from 'react';
import { useLocale } from '@/hooks/use-locale';
import { localizedHref } from '@/lib/i18n/href';

// Drop-in replacement for next/link that prepends the current locale to
// internal absolute paths. External URLs, fragments, already-localized
// paths, and exempt paths (/verify, /api) pass through unchanged.
type Props = Omit<LinkProps, 'href'> & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps | 'href'> & {
    href: string;
    children?: ReactNode;
};

const LocaleLink = forwardRef<HTMLAnchorElement, Props>(function LocaleLink({ href, ...rest }, ref) {
    const locale = useLocale();
    return <NextLink ref={ref} href={localizedHref(href, locale)} {...rest} />;
});

export default LocaleLink;
